import React from 'react';
import { IconCopyNew, IconEmail } from 'components/Icons';
import { prefixClass, showToast, TOAST_SUCCESS, FIVE_SECONDS, getHostEnvironment } from 'lib/utils';
import './DashboardEmail.scss';
import { Tooltip, Whisper } from 'rsuite';
import { generateEmailById } from '@hone-automation/common/lib/commonUtil';

type DashboardEmailProps = {
  email?: string;
};

export default function DashboardEmail({ email }: DashboardEmailProps) {
  const prefix = prefixClass('dashboard-email-container');

  const emailTooltip = email ? generateEmailById(email, getHostEnvironment()) : '';

  const handleCopyEmail = () => {
    if (emailTooltip) {
      navigator.clipboard.writeText(emailTooltip);
      showToast('Email copied to clipboard', TOAST_SUCCESS, FIVE_SECONDS);
    }
  };

  return (
    <Whisper
      placement="top"
      trigger="hover"
      delayOpen={500}
      delayClose={100}
      className="dashboard-email-tooltip"
      speaker={<Tooltip className="dashboard-email-tooltip-content">{emailTooltip}</Tooltip>}
    >
      <button className={prefix()} onClick={handleCopyEmail} disabled={!email} type="button">
        <div className={prefix('icon')}>
          <IconEmail />
        </div>
        <span>Queue Inbox</span>
        <div className={prefix('__copy')} aria-hidden="true">
          <IconCopyNew />
        </div>
      </button>
    </Whisper>
  );
}
